// компонент, который показывает ограниченный набор значений 56 УС, которые доступны в указанном офисе
import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';
import { SelectInput, MultiSelectInput } from '../forms';
import { partnerOfficeActions, PartnerOfficeStore } from '../../../partners/store/offices/partnerOfficeStore';

type Ref56ForOfficeSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    partnerOfficeStore?: PartnerOfficeStore,
    officeId: string,
    serviceId: number,
    multiSelect?: boolean,
    excludedValues?: Array<number>,
    addId?: number,
    addName?: string,
  };

const Ref56ForOfficeSelector = (props: Ref56ForOfficeSelectorProps) => {
  const {
    partnerOfficeStore,
    officeId,
    multiSelect,
    excludedValues,
    serviceId,
    addName,
    addId,
    name,
    label,
    disabled, 
    placeholder,
    ...rest
  } = props;

  const { refValuesForOffice56, refValuesForOfficeRequest56 } = partnerOfficeStore;

  const toAdd = addId ? [{ id: addId, name: addName, refId: 56 }] : [];
  const filteredValues = [...refValuesForOffice56, ...toAdd].filter((v) => (!(excludedValues ?? []).includes(v.id)));

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    if (officeId && serviceId) {
      if (
        (((refValuesForOfficeRequest56?.partnerOfficeId ?? '') !== officeId)
        || ((refValuesForOfficeRequest56?.serviceId ?? 0) !== serviceId))
         && (!loading)) {
        setLoading(true);
        await partnerOfficeActions.getRefValuesForOffice(
          {
            partnerOfficeId: officeId,
            serviceId,
            refId: 56,
          }
        ).finally(() => setLoading(false));
      }
    } else {
      partnerOfficeActions.clearOfficesServicesForSelector();
    }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officeId, serviceId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
          name={ name }
          label={ label }
          disabled={ disabled }
          placeholder={ placeholder }
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
          name={ name }
          label={ label }
          disabled={ disabled }
          placeholder={ placeholder }
        />
      )

  );
};

export default inject('partnerOfficeStore')(observer(Ref56ForOfficeSelector));
